import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const WorkAnniversary = React.lazy(() => import("@/pages/dashboard/WorkAnniversary"));

const Index = [
  {
    path: "/workAnniversary",
    element: (
      <SuspenseWrapper>
        <WorkAnniversary />
      </SuspenseWrapper>
    ),
  },
  {
    
  }
];

export default Index;
